import _ from "lodash";
import { dateFormatedToDB } from "../../functions";
import { PurchaseReportModel } from "../../models/reports";
import { usePurchaseReports } from "../../../store/reports/usePurchaseReport";

export default class PurchaseReportController {
  constructor() {
    this.name = "reports-purchase";
    this.tableName = `${this.name}-table`;
    this.paginationName = `${this.name}-pagination`;

    this.MPurchaseReport = PurchaseReportModel();

    this.init();
  }

  init = async () => {
    this.findPurchaseReports()
  };

  findPurchaseReports = async () => {
    await this.MPurchaseReport.findPurchaseReports();
  };

  setPage = (page) => {
    this.MPurchaseReport.setPage(page);
  };

  setFilter = (filterData) => {
    const filter = _.pickBy({
      dateFrom: dateFormatedToDB(filterData.dateFrom),
      dateTo: dateFormatedToDB(filterData.dateTo),
      department: filterData.department,
    }, _.identity);

    this.MPurchaseReport.setFilter({
      ...filter,
      brand: filterData.brand,
      description: filterData.description,
    });
  };

  setSort = (sortData) => {
    const sort = _.pickBy({
      field: sortData.field,
      direction: sortData.direction,
    }, _.identity);

    this.MPurchaseReport.setSort(sort);
  };

  /** Ordena pelo clique no cabecalho; o Table.Header manda so a chave, entao
   *  a direcao e alternada aqui. Compartilha o mesmo `sort` do select Ordem. */
  handleSortColumn = async (field) => {
    const sort = usePurchaseReports.getState().data.sort;
    const direction = sort.field === field && sort.direction === "-1" ? "1" : "-1";

    this.MPurchaseReport.setSort({ field, direction });
    await this.MPurchaseReport.filterPurchaseReports();
  };

  clearFilter = async () => {
    this.MPurchaseReport.setFilter({
      department: "*",
      brand: "",
      description: "",
    });
    this.MPurchaseReport.setSort({ field: "*", direction: "-1" });
    await this.MPurchaseReport.filterPurchaseReports();
  };

  filterPurchases = async (e) => {
    if (e) e.preventDefault();
    await this.MPurchaseReport.filterPurchaseReports();
  };

  reportExport = () => {
    this.MPurchaseReport.export();
  };
}
